import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ISystemConfigRegisterPayload } from './system-config.interface';

@Injectable({
  providedIn: 'root',
})
export class SystemConfigService {
  private http = inject(HttpClient);

  listAll() {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };

    return this.http.get<ISystemConfigRegisterPayload[]>(`${environment.api}/system-configs`, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  find(id: string) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };

    return this.http.get(`${environment.api}/system-configs/${id}`, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  findByReference(reference: string) {
    const token = sessionStorage.getItem('token') as string;
    let http: any = {};
    if (token) {
      http = {
        headers: new HttpHeaders({
          Authorization: sessionStorage.getItem('token') as string,
        }),
      };
    }

    return this.http.get(`${environment.api}/system-configs/reference/${reference}`, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  register(payload: ISystemConfigRegisterPayload) {
    if (payload.id) {
      return this.update(payload);
    } else {
      return this.create(payload);
    }
  }

  update(payload: ISystemConfigRegisterPayload) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };

    return this.http.put(`${environment.api}/system-configs/${payload.id}`, payload, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  create(payload: ISystemConfigRegisterPayload) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };

    return this.http.post(`${environment.api}/system-configs`, payload, http).pipe(
      (res) => res,
      (error) => error,
    );
  }

  delete(id: string) {
    const http = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };

    return this.http.delete(`${environment.api}/system-configs/${id}`, http).pipe(
      (res) => res,
      (error) => error,
    );
  }
}
